import { z } from 'zod';
import { DEFAULT_CURRENCY } from '../constants.js';
import { currencySchema } from './project.js';
// Enums
export const needCategoryEnum = z.enum([
    'FLOORING',
    'TILES',
    'PLUMBING',
    'LIGHTING',
    'ELECTRICAL',
    'DOORS',
    'KITCHEN',
    'WALLS_CEILING',
    'WINDOWS_TEXTILE',
    'FURNITURE',
    'ELECTRONICS',
    'CLIMATE',
    'SECURITY',
    'STORAGE',
    'GARDEN',
    'CLEANING',
    'TOOLS',
    'DECOR',
    'TEXTILE',
    'BATH',
    'OTHER',
]);
// Need schemas
export const createNeedSchema = z.object({
    title: z.string().min(1).max(255),
    category: needCategoryEnum.default('OTHER'),
    note: z.string().max(2000).optional(),
});
export const updateNeedSchema = z.object({
    title: z.string().min(1).max(255).optional(),
    category: needCategoryEnum.optional(),
    note: z.string().max(2000).nullable().optional(),
});
// Фото товара показывается через <img src>, поэтому только http(s), без javascript:/data:
const httpUrlSchema = z.string().url().max(2000).regex(/^https?:\/\//i);
// NeedOption schemas
export const createNeedOptionSchema = z.object({
    title: z.string().min(1).max(255),
    price: z.number().positive().optional(),
    currency: currencySchema.default(DEFAULT_CURRENCY),
    url: z.string().url().max(2000).optional().or(z.literal('')),
    imageUrl: httpUrlSchema.optional(),
    /** Загруженное фото (вложение NEED_OPTION_PHOTO) — показывается вместо imageUrl. */
    imageAttachmentId: z.string().max(64).optional(),
    description: z.string().max(2000).optional(),
});
export const updateNeedOptionSchema = z.object({
    title: z.string().min(1).max(255).optional(),
    price: z.number().positive().nullable().optional(),
    currency: currencySchema.optional(),
    url: z.string().url().max(2000).nullable().optional().or(z.literal('')),
    imageUrl: httpUrlSchema.nullable().optional(),
    imageAttachmentId: z.string().max(64).nullable().optional(),
    description: z.string().max(2000).nullable().optional(),
});
/** Новый порядок товаров подборки: все id в нужном порядке. */
export const reorderNeedOptionsSchema = z.object({
    ids: z.array(z.string()).min(1).max(500),
});
// Превью товара по ссылке: название, описание и цена со страницы магазина
export const productLinkPreviewInputSchema = z.object({
    url: z.string().trim().url().max(2000),
});
export const productLinkPreviewSchema = z.object({
    title: z.string().nullable(),
    description: z.string().nullable(),
    price: z.number().nullable(),
    currency: currencySchema.nullable(),
    image: z.string().nullable(),
    siteName: z.string().nullable(),
});
export const needOptionSchema = z.object({
    id: z.string(),
    needId: z.string(),
    title: z.string(),
    price: z.number().nullable(),
    currency: currencySchema,
    url: z.string().nullable(),
    imageUrl: z.string().nullable(),
    imageAttachmentId: z.string().nullable(),
    /** Подписанная ссылка на загруженное фото (срок жизни ограничен); null — фото не загружали. */
    uploadedImageUrl: z.string().nullable(),
    description: z.string().nullable(),
    isSelected: z.boolean(),
    position: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const needSchema = z.object({
    id: z.string(),
    projectId: z.string(),
    title: z.string(),
    category: needCategoryEnum,
    note: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    options: z.array(needOptionSchema).optional(),
    createdBy: z
        .object({
        id: z.string(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
        username: z.string().nullable(),
    })
        .nullable()
        .optional(),
    updatedBy: z
        .object({
        id: z.string(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
        username: z.string().nullable(),
    })
        .nullable()
        .optional(),
});
// Template schemas
export const applyNeedTemplateSchema = z.object({
    templateId: z.string(),
    // Опциональный массив индексов товаров для выборочного применения
    // Если не указан - применяются все товары
    selectedItemIndexes: z.array(z.number().int().min(0)).optional(),
});
export const needTemplateItemAdminSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1).max(255),
    category: needCategoryEnum,
    order: z.number().int().min(0),
});
export const needTemplateAdminSchema = z.object({
    id: z.string(),
    slug: z.string(),
    label: z.string(),
    description: z.string().nullable(),
    order: z.number(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
    items: z.array(needTemplateItemAdminSchema.extend({
        id: z.string(),
    })),
});
export const createNeedTemplateSchema = z.object({
    slug: z
        .string()
        .min(1)
        .max(100)
        .regex(/^[A-Z_]+$/, 'Slug must be uppercase with underscores'),
    label: z.string().min(1).max(255),
    description: z.string().max(1000).optional(),
    order: z.number().int().min(0).optional(),
    isActive: z.boolean().optional(),
    items: z.array(z.object({
        title: z.string().min(1).max(255),
        category: needCategoryEnum,
        order: z.number().int().min(0),
    })),
});
export const updateNeedTemplateSchema = z.object({
    slug: z
        .string()
        .min(1)
        .max(100)
        .regex(/^[A-Z_]+$/)
        .optional(),
    label: z.string().min(1).max(255).optional(),
    description: z.string().max(1000).nullable().optional(),
    order: z.number().int().min(0).optional(),
    isActive: z.boolean().optional(),
    items: z
        .array(z.object({
        id: z.string().optional(),
        title: z.string().min(1).max(255),
        category: needCategoryEnum,
        order: z.number().int().min(0),
    }))
        .optional(),
});
//# sourceMappingURL=need.js.map